// Configuration using environment variables
// React apps can only access env vars that start with REACT_APP_

// Debug: Log environment variables (remove this after debugging)
// console.log('Environment check:');
// console.log('NODE_ENV:', process.env.NODE_ENV);
// console.log('REACT_APP_AWS_BASE_PATH:', process.env.REACT_APP_AWS_BASE_PATH);
//console.log('All REACT_APP_ vars:', Object.keys(process.env).filter(key => key.startsWith('REACT_APP_')));

export const aws_base_path = process.env.REACT_APP_AWS_BASE_PATH || 'https://salerox.s3.amazonaws.com/';

// Google Maps API key
export const mapskey = process.env.REACT_APP_MAPS_API_KEY || 'mock-maps-api-key';

// Access key for authentication
export const accessKey = process.env.REACT_APP_INITIAL_ACCESS_KEY || 'my-initial-key';



// API base URL
export const api_base_url = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

// Service-specific base URLs
export const kitchenServiceUrl = process.env.REACT_APP_KITCHEN_SERVICE_URL || 'http://localhost:4001';
export const orderServiceUrl = process.env.REACT_APP_ORDER_SERVICE_URL || 'http://localhost:4002';
export const userServiceUrl = process.env.REACT_APP_USER_SERVICE_URL || 'http://localhost:4003';
export const uploadServiceUrl = process.env.REACT_APP_UPLOAD_SERVICE_URL || 'http://localhost:4004';
export const paymentServiceUrl = process.env.REACT_APP_PAYMENT_SERVICE_URL || 'http://localhost:4006';
export const hubServiceUrl = process.env.REACT_APP_HUB_SERVICE_URL || 'http://localhost:4007';

// WS Hub connection name/ID
export const connectionHub = process.env.REACT_APP_CONNECTION_HUB || 'salerox-hub';

// You can add more environment-based config here
// export const some_other_config = process.env.REACT_APP_OTHER_CONFIG || 'default-value';